module.exports = __webpack_public_path__ + "img/res2.eeb9fa27.jpg";